// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Menu from './Menu/Menu';
import { Default, Mobile } from '../../utils/responsive';
import { generateRandomNumber } from '../../utils/number';
import DotsDrawer from './DotsDrawer/DotsDrawer';

import style from './DotsMenu.scss';
import menuStyle from './Menu/Menu.scss';

export type Orientation = 'left' | 'right';

type Props = {
  orientation: Orientation;
  buttonStyle?: string;
  menuOptions: MenuOption[];
};

export type MenuOption = {
  color?: 'lightBlue' | 'orange' | 'red';
  icon?: string;
  labelIntl: string;
  link?: string;
  handler?: (e: Event) => void;
  disabled?: boolean;
};

type State = {
  openMenu: boolean;
};

export default class DotsMenu extends Component<Props, State> {
  state = {
    openMenu: false,
  };
  uniqueKey: string;

  constructor(props: Props) {
    super(props);
    const r = generateRandomNumber(true);
    if (typeof r === 'string') this.uniqueKey = r;
  }

  // Only in browser
  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  componentWillUnmount() {
    // Ensure to remove listener if loggedout with menu open
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  handleClickOutside(e: Event) {
    const wrap = document.querySelector(`.${menuStyle.menuWrap}[data-id="${this.uniqueKey}"]`);
    const dots = document.querySelector(`.${style.dotsButton}[data-id="${this.uniqueKey}"]`);
    if (wrap && dots && e.target instanceof Node) {
      const target = e.target;
      if (!dots.contains(target) && !wrap.contains(target)) {
        this.changeToClose();
      }
    }
  }

  changeOpen() {
    this.setState((state: State) => ({
      openMenu: !state.openMenu,
    }));
  }

  changeToClose() {
    this.setState({
      openMenu: false,
    });
  }

  handleClick(e: Event) {
    e.preventDefault();
    this.changeOpen();
  }

  render() {
    const { buttonStyle, menuOptions } = this.props;
    const { openMenu } = this.state;

    return [
      <button key="dotsButton"
              type="button"
              data-id={this.uniqueKey}
              className={classNames(style.dotsButton, buttonStyle)}
              onClick={this.handleClick.bind(this)}>...</button>,
      openMenu &&
      <Default key="menu">
        <Menu id={this.uniqueKey}
              options={menuOptions}/>
      </Default>,
      <Mobile key="menuDrawer">
        <DotsDrawer options={menuOptions}
                    openMenu={openMenu}
                    handleClickOutside={this.changeToClose.bind(this)}/>
      </Mobile>,
    ];
  }
}

DotsMenu.propTypes = {
  orientation: PropTypes.string,
  buttonStyle: PropTypes.string,
  menuOptions: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/DotsMenu/DotsMenu.jsx